export const PRODUCT_CARD_NOT_APPLICABLE_DATE = '1970-01-01'
export const STACK_N_LOAD = 'Stack’n Load'
export const WIND_SURFER = 'Wind Surfer'
export const MULT_GAME = 'Multiplication Master'
export const TREASURE_TRAIL = 'Treasure Trail'
export const TREASURE_TRAIL_STAGES_NO = 8
